import React, { Component } from "react";
import clsx from 'clsx';
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { connect } from 'react-redux';
import HeaderMenu from "../../components/header-menu";
import { Grid, Card, CardContent, Button, IconButton, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import BoltIcon from '@mui/icons-material/Bolt';
import VerifiedIcon from '@mui/icons-material/Verified';
import ReplayIcon from '@mui/icons-material/Replay';
import Api from "../../services/api";
import ApiReports from "../../services/apireport";
import CustomizedSnackbars from "../../components/material-snackbars";
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as calledsActions from '../../redux/actions/calleds';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleAutoCompleteSearch from '../../components/auto-complete/autocomplete-search-api';
import SimpleDatePicker from '../../components/date-pickers/inline-no-today';
import moment from 'moment';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getAllSelectionModel } from '../../services/techinicalteam.service';
import { getAllSelectionModelByTechnicalTeam } from '../../services/organization.service';
import { getAllUsersSelecionModelByRoleTypeAndOrganizationIdAndTechnicalTeamIdAndUserId } from '../../services/user.service';
import { getAllSelectionModel as getAllOriginRequestsSelectionModel } from '../../services/originrequest.service';
import * as AgentProductivityService from '../../services/agentproductivitydashboard.service';
import { evaluateSession } from '../../utils/sessionUtils';
import KpiCard from './components/kpi-card';
import TicketsByAgent from './components/tickets-by-agent';
import ChannelDonut from './components/channel-donut';
import CsatTable from './components/csat-table';
import NpsTable from './components/nps-table';
import PerformancePanel from './components/performance-panel';
import HourlyProductivityChart from './components/hourly-productivity-chart';
import DashboardSkeleton from './components/dashboard-skeleton';
import { getChartColors } from '../../utils/chartTheme';

const formatHoursLabel = hours => {
  const h = Math.floor(hours || 0);
  const m = Math.round(((hours || 0) - h) * 60);
  return `${h}h ${m}m`;
};

const aggregateTimeAverage = list => {
  if (!list || list.length === 0) return { hours: 0, label: '0h 0m' };
  const totalTime = list.reduce((sum, item) => sum + (item.totalattendancetime || item.totalsolutiontime || 0), 0);
  const totalCount = list.reduce((sum, item) => sum + (item.calledcount || 0), 0);
  const avgHours = totalCount > 0 ? totalTime / totalCount : 0;
  return { hours: avgHours, label: formatHoursLabel(avgHours) };
};

const buildDailySeries = list => (list || []).map(item => ({ date: item.date, count: item.count }));

const buildPercentSeries = list => (list || []).map(item => ({ date: item.date, count: item.percent }));

const formatPercent = (value, locale) => `${new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value || 0)}%`;

const defaultFilterValue = { id: 0, name: '' };

class AgentProductivityDashboard extends Component {

  constructor(props) {
    super(props);

    const { userSession } = this.props;
    evaluateSession(userSession);

    this.isClient = true;
    this.globalAdm = false;
    this.AdmOrganization = false;
    this.onlyAdmOrganization = false;
    this.isCoordenator = false;
    this.isTechinical = false;

    userSession.user.userrole.forEach((item) => {
      if (item.role.roletype != 3) this.isClient = false;
      if (item.role.roletype == 0) this.globalAdm = true;
      if (item.role.roletype == 1) this.AdmOrganization = true;
      if (item.role.roletype == 4) this.isCoordenator = true;
      if (item.role.roletype == 2) this.isTechinical = true;
    });
    if (this.AdmOrganization == true && this.globalAdm == false) {
      this.onlyAdmOrganization = true;
    }
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    this.state = {
      // Abrir em hoje->hoje mostrava zeros na primeira carga quase sempre; 30 dias da uma
      // leitura util de cara. Os atalhos abaixo do filtro cobrem os outros recortes.
      dateStart: moment().subtract(29, 'days').toDate(),
      dateEnd: new Date(),

      technicalTeamList: [],
      technicalTeam: { ...defaultFilterValue },
      organizationsList: [],
      organization: { ...defaultFilterValue },
      userList: [],
      userListVersion: 0,
      user: { ...defaultFilterValue },
      originRequestList: [],
      originRequest: { ...defaultFilterValue },

      summary: { totalassigned: 0, totalresolved: 0, assigneddailyseries: [], resolveddailyseries: [], assignedtrend: [], resolvedtrend: [], fcrtrend: [], slatrend: [], reopenedtrend: [] },
      byAgent: [],
      byChannel: [],
      hourly: [],
      csatData: [],
      npsData: [],
      slaPercent: 0,
      fcrPercent: 0,
      reopenedCount: 0,
      performanceMetrics: [],

      loading: true,
      showButtonPdf: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: ""
    };

    this.changeValues = this.changeValues.bind(this);
    this.search = this.search.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.getPdf = this.getPdf.bind(this);

    // Numero da busca corrente. Fica FORA do state de proposito: nao precisa provocar render,
    // e precisa ser lido de forma sincrona logo apos o incremento.
    this.searchSeq = 0;
  }

  /// Escreve no state APENAS se a busca que originou a resposta ainda for a corrente.
  ///
  /// Nada cancela requisicao em voo: buscar "1 ano" e logo depois "7 dias" deixa as duas
  /// correndo, e a primeira (mais lenta) chegava DEPOIS, sobrescrevendo os cards com dados que
  /// nao correspondem ao filtro na tela -- sem erro nenhum, porque as duas deram certo.
  /// Descartar a resposta atrasada resolve isso e, de quebra, cala o toast de erro das
  /// requisicoes da busca abandonada.
  applyIfCurrent(seq, patch) {
    if (seq !== this.searchSeq) return false;
    this.setState(patch);
    return true;
  }

  /// Erro de busca ja superada nao interessa mais ao usuario: ele esta olhando outro periodo.
  notifyErrorIfCurrent(seq, err) {
    if (seq !== this.searchSeq) return;
    this.notifyError(err);
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  notifyError(result) {
    const intl = this.props.intl;
    this.setState({
      openNotification: true,
      notificationVariant: "error",
      notificationMessage: result && result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
    });
    Api.kickoff(result);
  }

  async getAllSelectionModel() {
    const result = await getAllSelectionModel();
    if (result.success) {
      this.setState({ technicalTeamList: result.data });
    } else {
      this.notifyError(result);
    }
  }

  async getOrganizations(technicalTeam = '') {
    const result = await getAllSelectionModelByTechnicalTeam((technicalTeam == null || technicalTeam == '') ? 0 : technicalTeam);
    if (result.success) {
      this.setState({ organizationsList: result.data });
    } else {
      this.notifyError(result);
    }
  }

  // Mesmo padrão do dashboard de produtividade atual: SimpleAutoCompleteSearch usa "options" só
  // como valor inicial (useState não re-sincroniza em prop change), então precisamos forçar
  // remount via `key` (userListVersion) sempre que a lista recarrega — senão o combo fica preso
  // na lista (vazia) do primeiro render, e só a busca por digitação (urlapi) funcionaria.
  async getUsers(technicalTeam = '', organizationId = '') {
    const result = await getAllUsersSelecionModelByRoleTypeAndOrganizationIdAndTechnicalTeamIdAndUserId(2, (technicalTeam == null || technicalTeam == '') ? 0 : technicalTeam, (organizationId == null || organizationId == '') ? 0 : organizationId, 0);
    if (result.success) {
      this.setState(prevState => ({ userList: result.data, userListVersion: prevState.userListVersion + 1 }));
    } else {
      this.notifyError(result);
    }
  }

  async getOriginRequests() {
    const result = await getAllOriginRequestsSelectionModel();
    if (result.success) {
      this.setState({ originRequestList: result.data });
    } else {
      this.notifyError(result);
    }
  }

  getPreviousPeriod(dateStart, dateEnd) {
    const start = moment(dateStart);
    const end = moment(dateEnd);
    const days = end.diff(start, 'days') + 1;
    const prevEnd = start.clone().subtract(1, 'days');
    const prevStart = prevEnd.clone().subtract(days - 1, 'days');
    return {
      prevStart: prevStart.format('YYYY-MM-DD'),
      prevEnd: prevEnd.format('YYYY-MM-DD')
    };
  }

  async loadItems(technicalTeamId = 0, organizationId = 0, userId = 0, originRequestId = 0, seq = null) {
    const intl = this.props.intl;
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    const { prevStart, prevEnd } = this.getPreviousPeriod(dateStart, dateEnd);

    const [
      summaryResult,
      byAgentResult,
      byChannelResult,
      hourlyResult,
      attendanceTimeResult,
      solutionTimeResult,
      attendanceTimePrevResult,
      solutionTimePrevResult,
    ] = await Promise.all([
      AgentProductivityService.getSummary(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getByAgent(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getByChannel(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getHourly(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getAttendanceTime(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getSolutionTime(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getAttendanceTime(prevStart, prevEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getSolutionTime(prevStart, prevEnd, organizationId, technicalTeamId, userId, originRequestId),
    ]);

    if (summaryResult && summaryResult.success) {
      this.applyIfCurrent(seq, { summary: summaryResult.data || this.state.summary });
    }
    if (byAgentResult && byAgentResult.success) {
      this.applyIfCurrent(seq, { byAgent: byAgentResult.data || [] });
    }
    if (byChannelResult && byChannelResult.success) {
      this.applyIfCurrent(seq, { byChannel: byChannelResult.data || [] });
    }
    if (hourlyResult && hourlyResult.success) {
      this.applyIfCurrent(seq, { hourly: hourlyResult.data || [] });
    }

    const attendanceCurrent = aggregateTimeAverage(attendanceTimeResult && attendanceTimeResult.success ? attendanceTimeResult.data : []);
    const solutionCurrent = aggregateTimeAverage(solutionTimeResult && solutionTimeResult.success ? solutionTimeResult.data : []);
    const attendancePrevious = aggregateTimeAverage(attendanceTimePrevResult && attendanceTimePrevResult.success ? attendanceTimePrevResult.data : []);
    const solutionPrevious = aggregateTimeAverage(solutionTimePrevResult && solutionTimePrevResult.success ? solutionTimePrevResult.data : []);

    const percentChange = (current, previous) => {
      if (!previous) return null;
      return Math.round(((current - previous) / previous) * 100);
    };

    const tmrCurrent = attendanceCurrent.hours + solutionCurrent.hours;
    const tmrPrevious = attendancePrevious.hours + solutionPrevious.hours;

    // Linha com só 2 pontos (anterior -> atual): a mesma comparação usada pela seta/percentual,
    // pra garantir que a linha nunca contradiga a seta (baldes mensais dentro do período dão uma
    // tendência diferente da comparação período-atual-vs-anterior usada na seta).
    const attendanceSeries = [{ value: attendancePrevious.hours }, { value: attendanceCurrent.hours }];
    const solutionSeries = [{ value: solutionPrevious.hours }, { value: solutionCurrent.hours }];
    const tmrSeries = [{ value: tmrPrevious }, { value: tmrCurrent }];

    this.applyIfCurrent(seq, {
      performanceMetrics: [
        {
          label: intl.formatMessage({ id: 'agentproductivity.dashboard.performance.tme', defaultMessage: 'Tempo médio de espera (TME)' }),
          value: attendanceCurrent.label,
          comparation: percentChange(attendanceCurrent.hours, attendancePrevious.hours),
          series: attendanceSeries
        },
        {
          label: intl.formatMessage({ id: 'agentproductivity.dashboard.performance.tma', defaultMessage: 'Tempo médio de atendimento (TMA)' }),
          value: solutionCurrent.label,
          comparation: percentChange(solutionCurrent.hours, solutionPrevious.hours),
          series: solutionSeries
        },
        {
          label: intl.formatMessage({ id: 'agentproductivity.dashboard.performance.tmr', defaultMessage: 'Tempo médio de resolução (TMR)' }),
          value: formatHoursLabel(tmrCurrent),
          comparation: percentChange(tmrCurrent, tmrPrevious),
          series: tmrSeries
        },
      ]
    });

    // Estas cinco eram encadeadas com await, uma esperando a anterior sem precisar: nenhuma le o
    // resultado da outra, cada uma so escreve a propria chave de estado. Encadeadas, custavam a
    // soma dos tempos (~3,4s medidos); o custo real de cada uma e quase todo fixo por requisicao,
    // nao de consulta.
    //
    // Em DUAS ondas, e nao em uma so, de proposito: aqui a consulta custa ~zero, mas numa base
    // grande cada uma dessas e pesada, e disparar as cinco junto com o bloco de 8 acima poria 13
    // consultas simultaneas no pool por UM usuario. O encadeamento funcionava como estrangulador
    // acidental; duas ondas mantem metade do pico e ainda cortam a maior parte da espera.
    await Promise.all([
      this.getSla(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId, seq),
      this.getCsat(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId, seq),
      this.getNps(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId, seq),
    ]);

    await Promise.all([
      this.getFcr(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId, seq),
      this.getReopenedCount(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId, seq),
    ]);

    this.setState({ showButtonPdf: true });
  }

  // Antes vinha do /calleds/dashboard/montlysla, que devolve uma linha por mes (e roda uma
  // consulta por mes) porque a tela de SLA mensal precisa da serie. Este card mostra um numero
  // so, e a media ponderada por mes que era feita aqui da exatamente o percentual do periodo --
  // entao o periodo inteiro agora vem agregado do banco, numa consulta.
  async getSla(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0, seq = null) {
    const result = await AgentProductivityService.getSla(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    if (result && result.success) {
      this.applyIfCurrent(seq, { slaPercent: Math.round(result.data.solutionhitpercent || 0) });
    } else if (result) {
      this.notifyErrorIfCurrent(seq, result);
    }
  }

  async getCsat(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0, seq = null) {
    const result = await AgentProductivityService.getCsat(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    if (result && result.success) {
      this.applyIfCurrent(seq, { csatData: result.data });
    } else if (result) {
      this.notifyErrorIfCurrent(seq, result);
    }
  }

  async getNps(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0, seq = null) {
    const result = await AgentProductivityService.getNps(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    if (result && result.success) {
      this.applyIfCurrent(seq, { npsData: result.data });
    } else if (result) {
      this.notifyErrorIfCurrent(seq, result);
    }
  }

  async getFcr(dateStart, dateEnd, organizationId, technicalTeamId = 0, userId = 0, originRequestId = 0, seq = null) {
    const result = await AgentProductivityService.getFcr(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    if (result && result.success) {
      const total = result.data.numbertotal || 0;
      const inside = result.data.numbertotalinsidefcr || 0;
      this.applyIfCurrent(seq, { fcrPercent: total > 0 ? Math.round((inside / total) * 100) : 0 });
    } else if (result) {
      this.notifyErrorIfCurrent(seq, result);
    }
  }

  async getReopenedCount(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0, seq = null) {
    let url = `/report/reopenedcalleds/count?dateStart=${dateStart}&dateEnd=${dateEnd}&org=${organizationId}&status=0&techteam=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`;
    await ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          this.applyIfCurrent(seq, { reopenedCount: result.data.data || 0 });
        }
      })
      .catch(err => this.notifyErrorIfCurrent(seq, err));
  }

  async changeValues(stateName, value) {
    if (stateName === "technicalTeam") {
      this.setState({ technicalTeam: value, organization: { ...defaultFilterValue }, user: { ...defaultFilterValue } });
      await this.getOrganizations(value && value.id);
    } else if (stateName === "organization") {
      this.setState({ organization: value, user: { ...defaultFilterValue } });
      // A lista de agentes depende da organizacao, e este era o unico branch que nao a recarregava
      // -- so limpava a selecao. Enquanto o loadItems recarregava a cada busca isso passava
      // despercebido; tirando de la, a troca de organizacao deixaria o combo Agente vazio.
      await this.getUsers(this.state.technicalTeam.id, value && value.id);
    } else if (stateName === "user") {
      this.setState({ user: value });
      // Limpar o Agente (botão "X") faz o SimpleAutoCompleteSearch zerar sua lista
      // interna de opções (ele só recebe a lista pré-carregada uma vez, na montagem
      // — ver comentário em getUsers()) — sem recarregar aqui, reabrir o combo depois
      // de limpar mostra "No options" até o usuário digitar de novo. Só recarrega
      // quando a seleção é limpa (não a cada seleção normal, pra não remontar à toa).
      if (!value || !value.id) {
        await this.getUsers(this.state.technicalTeam.id, this.state.organization.id);
      }
    } else if (stateName === "dateStart" || stateName === "dateEnd") {
      // O date picker dispara onChange a cada tecla digitada, inclusive com datas parciais/inválidas
      // enquanto o usuário ainda está digitando. Se deixarmos essa data inválida entrar no estado,
      // ela volta pro próprio picker via prop `currentDate` e o campo "reseta" sozinho, sem aviso.
      if (moment(value).isValid()) {
        this.setState({ [stateName]: value });
      }
    } else {
      this.setState({ [stateName]: value });
    }
  }

  async search() {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    const intl = this.props.intl;

    if (dateStart > dateEnd) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date", defaultMessage: "Data inicial não pode ser maior que a data final" })
      });
      return;
    }

    // Marca esta busca. Qualquer resposta que chegar depois de uma busca mais nova e descartada.
    const seq = ++this.searchSeq;

    this.setState({ loading: true });
    try {
      await this.loadItems(
        this.state.technicalTeam && this.state.technicalTeam.id,
        this.state.organization && this.state.organization.id,
        this.state.user && this.state.user.id,
        this.state.originRequest && this.state.originRequest.id,
        seq
      );
    } finally {
      // finally e nao linha solta: sem ele, uma excecao no loadItems deixava "loading" preso em
      // true para sempre -- e com isso Atualizar e Exportar desabilitados ate recarregar a tela.
      // So desliga se esta ainda e a busca corrente; senao apagaria o indicador de uma mais nova.
      if (seq === this.searchSeq) this.setState({ loading: false });
    }
  }

  async clearFilters() {
    this.setState({
      dateStart: moment().subtract(29, 'days').toDate(),
      dateEnd: new Date(),
      technicalTeam: { ...defaultFilterValue },
      organization: { ...defaultFilterValue },
      user: { ...defaultFilterValue },
      originRequest: { ...defaultFilterValue }
    });
    await this.getOrganizations(0);
    await this.search();
  }

  async componentDidMount() {
    // getOrganizations saiu do loadItems: a lista nao muda quando se clica em Pesquisar, e ali ela
    // era recarregada a cada busca, bloqueando o inicio das consultas. Quem a mantem em dia agora
    // sao o proprio changeValues (troca de time) e o clearFilters; aqui e so a carga inicial.
    await Promise.all([
      this.getAllSelectionModel(),
      this.getOriginRequests(),
      this.getOrganizations(0),
    ]);
    await this.search();
  }

  async getPdf() {
    // Guarda contra clique duplo: se já tem uma exportação em andamento, ignora o novo clique
    // em vez de disparar um segundo html2canvas/jsPDF concorrente.
    if (this.state.loading) return;

    this.setState({ loading: true });
    try {
      const content = document.getElementById('agent-productivity-dashboard-content');
      if (content != null) {
        // A pagina era criada do tamanho EXATO do canvas, em pt: saia um unico "papel" gigante,
        // que leitor nenhum mostra inteiro e que imprime cortado. Agora e A4 de verdade, com a
        // imagem ajustada a largura util e fatiada em paginas.
        //
        // A captura usa scrollWidth/scrollHeight, e nao o tamanho da caixa, como defesa: nas
        // larguras medidas aqui o conteudo NAO transborda (scrollWidth == offsetWidth), mas a
        // margem negativa do <Grid container spacing={2}> pode faze-lo transbordar em outras --
        // e o que transborda a caixa fica de fora da captura. Nao custa nada e fecha esse caso.
        const exportWidth = Math.max(content.scrollWidth, content.offsetWidth);
        const exportHeight = Math.max(content.scrollHeight, content.offsetHeight);

        // 1.5 em vez de 2: na escala 2 este dashboard gerava ~29MB, grande demais para anexar
        // num e-mail. A 1.5 o texto continua legivel e o arquivo cai para perto da metade.
        // Dashboards longos caem para 1 porque canvas tem limite de area no navegador -- acima
        // dele a captura volta em branco, e perder nitidez e melhor que perder o PDF.
        const scale = exportHeight > 6000 ? 1 : 1.5;

        const canvas = await html2canvas(content, {
          scale,
          backgroundColor: '#ffffff',
          useCORS: true,
          scrollX: 0,
          scrollY: -window.scrollY,
          windowWidth: document.documentElement.scrollWidth,
          width: exportWidth,
          height: exportHeight
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 16;
        const usableWidth = pageWidth - margin * 2;
        const imgHeight = (canvas.height * usableWidth) / canvas.width;

        const pages = Math.max(1, Math.ceil(imgHeight / pageHeight));
        for (let page = 0; page < pages; page += 1) {
          if (page > 0) pdf.addPage();
          // A imagem inteira entra em toda pagina, deslocada pra cima; o recorte da pagina
          // mostra so a faixa correspondente.
          pdf.addImage(imgData, 'PNG', margin, -(page * pageHeight), usableWidth, imgHeight);
        }

        pdf.save('dashboard-produtividade-agente.pdf');
      }
    } catch (err) {
      // Sem isso, uma falha no html2canvas/jsPDF (imagem CORS-taintada, fonte ainda carregando, etc.)
      // interrompia a função antes do "loading: false" e prendia o indicador pra sempre.
      this.notifyError(err);
    } finally {
      this.setState({ loading: false });
    }
  }

  // Atalhos de periodo: a tela abre em 30 dias, e estes cobrem os recortes mais pedidos sem
  // obrigar a mexer nos dois date pickers.
  periodPresets() {
    const intl = this.props.intl;
    return [
      { id: 'today', label: intl.formatMessage({ id: 'agentproductivity.dashboard.period.today', defaultMessage: 'Hoje' }), start: moment().toDate() },
      { id: 'last7', label: intl.formatMessage({ id: 'agentproductivity.dashboard.period.last7', defaultMessage: '7 dias' }), start: moment().subtract(6, 'days').toDate() },
      { id: 'last30', label: intl.formatMessage({ id: 'agentproductivity.dashboard.period.last30', defaultMessage: '30 dias' }), start: moment().subtract(29, 'days').toDate() },
      { id: 'month', label: intl.formatMessage({ id: 'agentproductivity.dashboard.period.month', defaultMessage: 'Mês atual' }), start: moment().startOf('month').toDate() }
    ];
  }

  applyPeriodPreset(preset) {
    this.setState({ dateStart: preset.start, dateEnd: new Date() }, () => this.search());
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;
    const colors = getChartColors();

    // O combo de Agente depende de Time + Organizacao (a lista de usuarios e buscada por esses
    // dois ids); sem eles fica desabilitado, e o tooltip explica o porque.
    const agentFilterEnabled = !!(this.state.technicalTeam && this.state.technicalTeam.id > 0
      && this.state.organization && this.state.organization.id > 0);

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} style={{ minWidth: '300px' }} />
          <div id="agent-productivity-dashboard-content" style={{ paddingRight: 24, paddingLeft: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                          <span style={{ fontSize: 24, fontWeight: 700 }}>
                            <FormattedMessage id="agentproductivity.dashboard.title" defaultMessage="Dashboard de Produtividade do Agente" />
                          </span>
                        </Grid>
                        <Grid item>
                          <Tooltip title={intl.formatMessage({ id: 'refresh', defaultMessage: 'Atualizar' })}>
                            <span>
                              <IconButton size="small" color="secondary" onClick={this.search} disabled={this.state.loading}>
                                <RefreshIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      {this.state.showButtonPdf && (
                        <Button variant="contained" color="secondary" onClick={this.getPdf} disabled={this.state.loading}>
                          <FormattedMessage id="agentproductivity.dashboard.export" defaultMessage="Exportar" />
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleDatePicker
                    label={intl.formatMessage({ id: "start.date" })}
                    name="dateStart"
                    stateName="dateStart"
                    changeDate={this.changeValues}
                    currentDate={this.state.dateStart}
                    required />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleDatePicker
                    label={intl.formatMessage({ id: "end.date" })}
                    name="dateEnd"
                    stateName="dateEnd"
                    changeDate={this.changeValues}
                    currentDate={this.state.dateEnd}
                    required />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "productivity.dashboard.techinical.teams", defaultMessage: "Times de atendimento" })}
                    options={this.state.technicalTeamList}
                    stateName="technicalTeam"
                    changeSelect={this.changeValues}
                    selected={this.state.technicalTeam} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "productivity.dashboard.organizations", defaultMessage: "Organização" })}
                    options={this.state.organizationsList}
                    stateName="organization"
                    changeSelect={this.changeValues}
                    selected={this.state.organization} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "agentproductivity.dashboard.channel", defaultMessage: "Canal" })}
                    options={this.state.originRequestList}
                    stateName="originRequest"
                    changeSelect={this.changeValues}
                    selected={this.state.originRequest} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  {/* placement="top": no padrao (bottom) a dica caía exatamente sobre o botao
                      Pesquisar, escondendo-o. Acima do campo o espaco esta livre.

                      disableInteractive: por padrao o MUI mantem a dica aberta enquanto o cursor
                      estiver sobre ELA, nao so sobre o campo -- descendo o mouse, a pessoa entrava
                      na propria dica e ela nao sumia. */}
                  <Tooltip
                    placement="top"
                    disableInteractive
                    title={agentFilterEnabled ? '' : intl.formatMessage({ id: 'agentproductivity.dashboard.agent.hint', defaultMessage: 'Selecione um Time de atendimento e uma Organização para escolher o agente.' })}
                  >
                    <span>
                      <SimpleAutoCompleteSearch
                        key={this.state.userListVersion}
                        label={intl.formatMessage({ id: "agentproductivity.dashboard.agent", defaultMessage: "Agente" })}
                        options={this.state.userList}
                        stateName="user"
                        changeSelect={this.changeValues}
                        selected={this.state.user}
                        urlapi={Api.apiurlbase() + 'api/users/selectionmodel/search/2/' + this.state.technicalTeam.id + '/' + this.state.organization.id}
                        disabled={!agentFilterEnabled} />
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                <Grid item xs="auto" style={{ marginRight: 'auto' }}>
                  <Grid container spacing={1}>
                    {this.periodPresets().map(preset => (
                      <Grid item key={preset.id}>
                        <Button size="small" variant="outlined" color="secondary" onClick={() => this.applyPeriodPreset(preset)}>
                          {preset.label}
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs="auto">
                  {/* Desabilitados durante a busca, igual a Atualizar e Exportar. Nao e mais
                      protecao contra sobreposicao -- disso cuida a guarda de sequencia -- e sim
                      sinal de que ja tem busca em andamento. Depende do try/finally em search():
                      sem ele, uma excecao deixaria "loading" preso e a tela travada. */}
                  <Button variant="contained" color="secondary" onClick={this.search} disabled={this.state.loading}>
                    <FormattedMessage id="search" defaultMessage="Pesquisar" />
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button variant="outlined" color="secondary" onClick={this.clearFilters} disabled={this.state.loading}>
                    <FormattedMessage id="agentproductivity.dashboard.clear" defaultMessage="Limpar" />
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <DashboardSkeleton loading={this.state.loading}>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.assigned', defaultMessage: 'Atribuídos' })}
                value={this.state.summary.totalassigned}
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.assigned.subtitle', defaultMessage: 'abertos no período' })}
                series={buildDailySeries(this.state.summary.assignedtrend)}
                icon={<AssignmentIndIcon />}
                accentColor={colors.info}
                tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.assigned.tooltip', defaultMessage: 'Chamados abertos no período selecionado, contados pela data de abertura.' })}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.resolved', defaultMessage: 'Resolvidos' })}
                value={this.state.summary.totalresolved}
                // Atribuídos conta por data de abertura e Resolvidos por data de resolução (1ª
                // vez que o chamado virou status "resolvido") -- datas diferentes, então
                // Resolvidos não é um subconjunto de Atribuídos (pode incluir chamado aberto
                // antes do período e resolvido dentro dele). Por isso o subtítulo não compara
                // percentual entre os dois, só descreve o próprio período.
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.resolved.subtitle', defaultMessage: 'resolvidos no período' })}
                series={buildDailySeries(this.state.summary.resolvedtrend)}
                icon={<TaskAltIcon />}
                accentColor={colors.primary}
                tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.resolved.tooltip', defaultMessage: 'Chamados resolvidos no período, contados pela data da primeira resolução. Pode ficar acima de Atribuídos, porque inclui chamados abertos antes do período.' })}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.fcr', defaultMessage: 'FCR' })}
                value={`${this.state.fcrPercent}%`}
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.fcr.subtitle', defaultMessage: 'resolução no 1º contato' })}
                series={buildPercentSeries(this.state.summary.fcrtrend)}
                icon={<BoltIcon />}
                accentColor={colors.accentPurple}
                tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.fcr.tooltip', defaultMessage: 'FCR (First Contact Resolution) — percentual de chamados resolvidos no primeiro contato, sem precisar de novas interações.' })}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.sla', defaultMessage: 'SLA cumprido' })}
                value={`${this.state.slaPercent}%`}
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.sla.subtitle', defaultMessage: 'dentro do prazo' })}
                series={buildPercentSeries(this.state.summary.slatrend)}
                icon={<VerifiedIcon />}
                accentColor={colors.warning}
                tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.sla.tooltip', defaultMessage: 'Percentual de chamados que cumpriram o SLA de solução dentro do prazo, no período selecionado.' })}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.reopened', defaultMessage: 'Reabertos' })}
                value={this.state.reopenedCount}
                subtitle={intl.formatMessage(
                  { id: 'agentproductivity.dashboard.reopened.subtitle', defaultMessage: '{percent} dos resolvidos no período' },
                  { percent: formatPercent(this.state.summary.totalresolved > 0 ? (this.state.reopenedCount / this.state.summary.totalresolved) * 100 : 0, intl.locale) }
                )}
                series={buildDailySeries(this.state.summary.reopenedtrend)}
                icon={<ReplayIcon />}
                accentColor={colors.error}
                tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.reopened.tooltip', defaultMessage: 'Chamados que voltaram a ser abertos depois de resolvidos, no período selecionado.' })}
              />
            </Grid>

            <Grid item xs={12} md={7}>
              <TicketsByAgent data={this.state.byAgent} />
            </Grid>
            <Grid item xs={12} md={5}>
              <ChannelDonut data={this.state.byChannel} />
            </Grid>

            <Grid item xs={12} md={6}>
              <CsatTable data={this.state.csatData} />
            </Grid>
            <Grid item xs={12} md={6}>
              <NpsTable data={this.state.npsData} />
            </Grid>

            <Grid item xs={12} md={4}>
              <PerformancePanel metrics={this.state.performanceMetrics} />
            </Grid>
            <Grid item xs={12} md={8}>
              <HourlyProductivityChart data={this.state.hourly} />
            </Grid>
            </DashboardSkeleton>
          </Grid>
          </div>

          <CustomizedSnackbars
            variant={this.state.notificationVariant}
            message={this.state.notificationMessage}
            isOpen={this.state.openNotification}
            toClose={this.closeNotification} />
        </main>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chatHubConnection: state.chatHubConnection,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AgentProductivityDashboard)));
